<template>
  <a-button
    size="small"
    class="d-flex align-items-center w-100"
    v-if="hasTitle"
    @click="getData(data)"
  >
    <vue-feather type="eye" class="text-primary me-1" />
    {{ title }}
  </a-button>
  <vue-feather type="eye" @click="getData(data)" class="text-primary" v-else />
  <a-drawer width="70%" placement="right" v-model:visible="visible">
    <a-card
      :bordered="false"
      :loading="isLoading"
      class="my-2"
      v-if="showDomain"
      :class="theme == 'light' ? 'bg-white' : 'bg-dark bg-dark-mode'"
    >
      <template #title>
        <h5 class="text-primary fw-bold font-size-16 m-0 p-0">Domain Info</h5>
      </template>
      <a-row :gutter="[16, 0]" class="m-0">
        <a-col :sm="8" :md="8" :xl="8" :span="24">
          <label class="text-secondary">Domain :</label>
          <p>{{ newData?.domain_detail?.domain_name ?? "-" }}</p>
        </a-col>
        <a-col :sm="24" :md="24" :xl="24" :span="24">
          <label class="text-secondary">Domain Description :</label>
          <p>{{ newData?.domain_detail?.domain_description ?? "-" }}</p>
        </a-col>
      </a-row>
    </a-card>

    <a-card
      :bordered="false"
      class="m-0 my-2"
      :loading="isLoading"
      :class="theme == 'light' ? 'bg-white' : 'bg-dark bg-dark-mode'"
    >
      <template #title>
        <h5 class="text-primary fw-bold font-size-16 m-0 p-0">Device Info</h5>
      </template>
      <a-row :gutter="[16, 0]" class="m-0">
        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">Serial Number :</label>
          <p>{{ newData?.serial_number ?? "-" }}</p>
        </a-col>
        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">MAC Address :</label>
          <p>{{ newData?.mac_address ?? "-" }}</p>
        </a-col>

        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">Public IP :</label>
          <p>{{ newData?.public_ip ?? "-" }}</p>
        </a-col>
        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">ROS Version :</label>
          <p>
            {{ newData?.ros_version ?? "-" }}
          </p>
        </a-col>

        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">Active Interface :</label>
          <p>{{ newData?.active_interface ?? "-" }}</p>
        </a-col>
        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">CPU Load :</label>
          <p>
            {{ newData?.cpu_load ?? "-" }}
          </p>
        </a-col>
        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">Used Memory :</label>
          <p>
            {{ newData?.used_memory ? bytesToMB(newData.used_memory) : "-" }}
          </p>
        </a-col>
        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">Free Memory :</label>
          <p>
            {{ newData?.free_memory ? bytesToMB(newData.free_memory) : "-" }}
          </p>
        </a-col>

        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">Sync At :</label>
          <p>
            <span class="d-block m-0">
              {{
                newData?.sycn_at ? `${datifier(newData.sycn_at)} (UTC)` : "-"
              }}
            </span>
            <span class="d-block m-0">
              {{
                newData?.sycn_at
                  ? `${datifierMoment(newData.sycn_at)} (DOMAIN)`
                  : "-"
              }}
            </span>
          </p>
        </a-col>
        <a-col :sm="6" :md="6" :xl="6" :span="24">
          <label class="text-secondary">Up Time :</label>
          <p>{{ newData?.up_time ?? "-" }}</p>
        </a-col>
      </a-row>
    </a-card>

    <a-card
      :bordered="false"
      :loading="isLoading"
      v-if="newData?.dhcp_leases && newData?.dhcp_leases.length !== 0"
      class="my-2"
      :class="theme == 'light' ? 'bg-white' : 'bg-dark bg-dark-mode'"
    >
      <template #title>
        <h5 class="text-primary fw-bold font-size-16 m-0 p-0">
          Other Info (DHCP Leases)
        </h5>
      </template>
      <div class="table-title">
        <a-table
          :columns="collumns"
          :dataSource="newData?.dhcp_leases"
          :loading="isLoading"
          :scroll="{ x: 1000 }"
          :pagination="false"
          :class="theme == 'light' ? 'bg-white' : 'bg-dark bg-dark-mode'"
        >
          <template #bodyCell="{ column, record }">
            <div v-if="column.key === 'address'">
              <span>
                {{ record?.address ?? "-" }}
              </span>
            </div>
            <div v-if="column.key === 'clientId'">
              <span>
                {{ record?.clientId ?? "-" }}
              </span>
            </div>
            <div v-if="column.key === 'expireAfter'">
              <span>
                {{ record?.expireAfter ?? "-" }}
              </span>
            </div>
            <div v-if="column.key === 'macAddress'">
              <span>
                {{ record?.macAddress ?? "-" }}
              </span>
            </div>
            <div v-if="column.key === 'dstPort'">
              <span>
                {{ record?.firewall_port?.dstPort ?? "-" }}
              </span>
            </div>
            <div v-if="column.key === 'toPorts'">
              <span>
                {{ record?.firewall_port?.toPorts ?? "-" }}
              </span>
            </div>
            <div v-if="column.key === 'protocol'">
              <span>
                {{ record?.firewall_port?.protocol ?? "-" }}
              </span>
            </div>
          </template>
        </a-table>
      </div>
    </a-card>
  </a-drawer>
</template>

<script>
import mikrotikDeviceService from "@/helpers/apiServices/mikrotikDevice.service";
import errorHandler from "@/helpers/errorHandler";
import { authComputed, layoutComputed } from "@/store/helpers";
import moment from "moment-timezone";
import dayjs from "dayjs";

export default {
  data() {
    return {
      newData: {},
      isLoading: true,
      visible: false,
      collumns: [
        {
          title: "MAC Address",
          dataIndex: "macAddress",
          key: "macAddress",
        },
        {
          title: "Address",
          dataIndex: "address",
          key: "address",
        },
        {
          title: "Client ID",
          dataIndex: "clientId",
          key: "clientId",
        },
        {
          title: "Last Seen",
          dataIndex: "lastSeen",
          key: "lastSeen",
        },
        {
          title: "Expires In",
          dataIndex: "expireAfter",
          key: "expireAfter",
        },
        {
          title: "DST Port",
          dataIndex: "dstPort",
          key: "dstPort",
        },
        {
          title: "To Port",
          dataIndex: "toPorts",
          key: "toPorts",
        },
        {
          title: "Protocol",
          dataIndex: "protocol",
          key: "protocol",
        },
      ],
    };
  },
  props: {
    data: { type: Object, required: true },
    showDomain: { type: Boolean, required: false, default: true },
    hasTitle: { type: Boolean, required: false, default: false },
    title: { type: String, required: false, default: "-" },
  },
  computed: { ...authComputed, ...layoutComputed },
  mounted() {},
  methods: {
    // Get detailed data
    async getData(data) {
      this.isLoading = true;
      this.visible = true;
      this.newData = {};
      await mikrotikDeviceService
        .getPPTPUserDetails(data.mikrotik_uuid)
        .then((res) => {
          if (!res.status) {
            this.isLoading = false;
            return;
          }
          this.newData = res.result;
          this.isLoading = false;
        })
        .catch((err) => {
          this.isLoading = false;
          errorHandler(err);
        });
    },
    datifier(date) {
      return dayjs(date).format("YYYY-MM-DD HH:mm:ss A");
    },
    datifierMoment(date) {
      return moment(date)
        .tz(this.domain.domain_timezone)
        .format("YYYY-MM-DD HH:mm:ss A");
    },
    bytesToMB(bytes) {
      const MB = bytes / (1024 * 1024 * 8);
      return `${MB.toFixed(2)} MB`;
    },
  },
};
</script>
